import {ShiftModel} from './shift.model';

export class ShiftFilterUpdate {
  constructor(readonly shift: ShiftModel|null,
              readonly source: string|null) {}
}
